import { render } from "./FullPageCarousel.vue?vue&type=template&id=06ff99b4&scoped=true"
import script from "./FullPageCarousel.vue?vue&type=script&lang=js"
export * from "./FullPageCarousel.vue?vue&type=script&lang=js"

import "./FullPageCarousel.vue?vue&type=style&index=0&id=06ff99b4&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ff99b4"]])

export default __exports__